/* global axios */
import ApiClient from './ApiClient';

class CallsAPI extends ApiClient {
  constructor() {
    super('calls', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getMetrics(params = {}) {
    return axios.get(`${this.url}/metrics`, { params });
  }

  download(params = {}) {
    return axios.get(`${this.url}/download`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new CallsAPI();
